import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const EditTenantSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'UUID do tenant é obrigatório' }),
  name: T.Optional(T.String({ minLength: 1, maxLength: 255, error: 'Nome do tenant é obrigatório' })),
  slug: T.Optional(
    T.String({
      minLength: 2,
      maxLength: 50,
      pattern: '^[a-z0-9-]+$',
      error: 'Slug deve conter apenas letras minúsculas, números e hífens',
    })
  ),
  domain: T.Optional(
    T.Union([
      T.String({
        minLength: 4,
        maxLength: 255,
        pattern: '^[a-z0-9][a-z0-9.-]*[a-z0-9]$',
        error: 'Domínio deve ser um hostname válido (ex: cliente.shelflix.com.br)',
      }),
      T.Null(),
    ])
  ),
  themeColor: T.Optional(
    T.String({
      minLength: 7,
      maxLength: 7,
      pattern: '^#[0-9A-Fa-f]{6}$',
      error: 'Cor deve estar no formato hexadecimal (#RRGGBB)',
    })
  ),
  logoFileType: T.Optional(T.String({ error: 'Tipo de arquivo da logo' })),
  logoDarkFileType: T.Optional(T.String({ error: 'Tipo de arquivo da logo dark' })),
  faviconFileType: T.Optional(T.String({ error: 'Tipo de arquivo do favicon' })),
  magicInfoRootDeviceGroupId: T.Optional(T.Union([T.String({ maxLength: 80 }), T.Null()])),
  magicInfoRootContentGroupId: T.Optional(T.Union([T.String({ maxLength: 80 }), T.Null()])),
  magicInfoRootPlaylistGroupId: T.Optional(T.Union([T.String({ maxLength: 80 }), T.Null()])),
  magicInfoRootScheduleGroupId: T.Optional(T.Union([T.String({ maxLength: 80 }), T.Null()])),
  isActive: T.Optional(T.Boolean()),
});

export type EditTenantInputType = typeof EditTenantSchema.static;

export async function ValidateEditTenantInput(value: unknown): Promise<EditTenantInputType> {
  return Value.Parse(EditTenantSchema, value);
}

export function checkTenantEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditTenantSchema, field, value);
}
